<template>
  <v-main>
    <v-container v-show="showParameters" fluid class="mt-3" >
      <v-row dense no-gutters>
        <v-col cols="2" class="mx-2">
          <v-text-field v-model="huovCode" label="Rentalcontract ID" @keyup.enter="getHuov"></v-text-field>
        </v-col>
        <v-col cols="2" class="mx-2">
          <v-text-field v-model="huisCode" hint="Search values beginning with..." label="Accommodation ID" @keyup.enter="getHuov"></v-text-field>
        </v-col>
        <v-col cols="6" class="mx-2">
          <select_hust_codes :selected_husttypes="hustCodesSelected" field="hustCodesSelected" :isClearable="true"
            @updateData="updateData" :localStorageItem="localStorageItem"></select_hust_codes>
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2" class="mx-2">
          <v-menu v-model="huovDatVanmenu" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="huovDatVan" label="Booking date from" clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="hulpDate" :first-day-of-week="1"
              @input="huovDatVan = $moment(hulpDate).format('DD-MM-YYYY'); huovDatVanmenu = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" class="mx-2">
          <v-menu v-model="huovDatTmmenu" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="huovDatTm" label="Booking date until" clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="hulpDate" :first-day-of-week="1"
              @input="huovDatTm = $moment(hulpDate).format('DD-MM-YYYY'); huovDatTmmenu = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2" class="mx-2">
          <v-menu v-model="huovAnnDatVanmenu" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="huovAnnDatVan" label="Cancellation date from" clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="hulpDate" :first-day-of-week="1"
              @input="huovAnnDatVan = $moment(hulpDate).format('DD-MM-YYYY'); huovAnnDatVanmenu = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" class="mx-2">
          <v-menu v-model="huovAnnDatTmmenu" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="huovAnnDatTm" label="Cancellation date until" clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="hulpDate" :first-day-of-week="1"
              @input="huovAnnDatTm = $moment(hulpDate).format('DD-MM-YYYY'); huovAnnDatTmmenu = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2" class="mx-2">
          <v-menu v-model="huovVanDatVanmenu" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="huovVanDatVan" label="Arrival date from" clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="hulpDate" :first-day-of-week="1"
              @input="huovVanDatVan = $moment(hulpDate).format('DD-MM-YYYY'); huovVanDatVanmenu = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" class="mx-2">
          <v-menu v-model="huovVanDatTmmenu" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="huovVanDatTm" label="Arrival date until" clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="hulpDate" :first-day-of-week="1"
              @input="huovVanDatTm = $moment(hulpDate).format('DD-MM-YYYY'); huovVanDatTmmenu = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2" class="mx-2">
          <v-menu v-model="huovTmDatVanmenu" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="huovTmDatVan" label="Departure date from" clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="hulpDate" :first-day-of-week="1"
              @input="huovTmDatVan = $moment(hulpDate).format('DD-MM-YYYY'); huovTmDatVanmenu = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" class="mx-2">
          <v-menu v-model="huovTmDatTmmenu" :close-on-content-click="false" :nudge-right="40"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="huovTmDatTm" label="Departure date until" clearable v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="hulpDate" :first-day-of-week="1"
              @input="huovTmDatTm = $moment(hulpDate).format('DD-MM-YYYY'); huovTmDatTmmenu = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="1" class="mx-2">
          <v-text-field v-model="klntCode" label="Guest ID" @keyup.enter="getHuov"></v-text-field>
        </v-col>
        <v-col cols="2" class="mx-2">
          <v-text-field v-model="klntEmail" label="Guest email" @keyup.enter="getHuov" autocomplete="new-guest-email"></v-text-field>
        </v-col>
        <v-col cols="2" class="mx-2">
          <v-text-field v-model="klntNaam" hint="Use of wildcards (*<input>*) supported" label="Guest lastname" autocomplete="new-guest-name" @keyup.enter="getHuov"></v-text-field>
        </v-col>
        <v-col cols="1" class="mx-2">
          <v-text-field v-model="klntTelefoon" hint="Use of wildcards (*<input>*) supported" label="Guest telephone" autocomplete="new-guest-telephone" @keyup.enter="getHuov"></v-text-field>
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="1" class="mx-2">
          <v-text-field v-model="eignCode" label="Host ID" @keyup.enter="getHuov"></v-text-field>
        </v-col>
        <v-col cols="2" class="mx-2">
          <v-text-field v-model="eignEmail" hint="Search values beginning with..." label="Host email" autocomplete="new-host-email" @keyup.enter="getHuov"></v-text-field>
        </v-col>
        <v-col cols="2" class="mx-2">
          <v-text-field v-model="eignNaam" hint="Search values beginning with..." label="Host lastname" autocomplete="new-host-lastname" @keyup.enter="getHuov"></v-text-field>
        </v-col>
        <v-col cols="1" class="mx-2">
          <v-text-field v-model="eignTelefoon" hint="Use of wildcards (*<input>*) supported" label="Host telephone" autocomplete="new-host-telephone" @keyup.enter="getHuov"></v-text-field>
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="2" class="mx-2">
          <v-autocomplete v-model="inpt_code" :items="inpt_codeKeuzes" item-value="inpt_code" item-text="inpt_naam"
            label="Sales partner"></v-autocomplete>
        </v-col>
        <v-col cols="2" class="mx-2">
          <v-text-field v-model="huovOtaCode" label="Sales partner booking ID" @keyup.enter="getHuov"></v-text-field>
        </v-col>
        <v-col cols="2" class="mx-2">
          <v-checkbox v-model="huovTest" label="Include test bookings"></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="1" span="2" style="display: flex; flex-direction: row; gap: 20px;" class="mx-2">
          <v-btn class="warning ma-0" small @click="parametersShow()" v-if="showClearButton"><v-icon left>mdi-refresh</v-icon>Clear</v-btn>
          <v-btn class="primary ma-0" small @click="getHuov()"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
          <v-btn v-if="filteredItems.length>0" class="primary ma-0" small @click="showParameters=false"><v-icon left>mdi-eye-off-outline</v-icon>Hide parameters</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid :class="{'smallfont': $vuetify.breakpoint.lgAndDown}">
      <v-btn v-show="!showParameters" class="primary ma-0" small @click="parametersShow()"><v-icon left>mdi-eye-outline</v-icon>Show parameters</v-btn>
      <div v-if="results">
        <v-card flat class="px-2 mt-1">
          <div style="display: flex; align-items: center; gap: 20px; margin-right: 40px;">
              <v-text-field v-model="search" label="Search in results" single-line hide-details prepend-icon="mdi-magnify"></v-text-field> 
              <v-checkbox hide-details dense v-model="filterOpenAmountKlnt" label="Guest only open" style="margin-top: 20px;"></v-checkbox>            
              <v-checkbox hide-details dense v-model="filterOpenAmountEign" label="Host only open" style="margin-top: 20px;"></v-checkbox>  
          </div>
          <v-data-table :items="filteredItems" :headers="headers" hide-default-footer :search="search"
            :items-per-page="getRowsPerPage()" :page.sync="page" no-data-text="No bookings to display"
            loading-text="Loading data...please wait" :loading="loading">
            <template v-slot:item="props">
              <tr>
                <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid)" class="font-row"><a>
                    {{ props.item.huov_code }} </a></td>
                <td class="font-row"><v-chip small :color=props.item.hust_kleur><span class="chiptext">{{
                  props.item.hust_code }}</span></v-chip></td>
                <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)" class="font-row"><a> {{
                  props.item.huis_code }} </a></td>
                <td class="font-row">{{ $moment(props.item.huov_dt).format("DD-MMM-YYYY HH:mm") }}</td>
                <td class="font-row">{{ props.item.huov_pers }}</td>
                <td class="font-row">{{ $moment(props.item.huov_van_dat).format("DD-MMM-YYYY ddd") }}</td>
                <td class="font-row">{{ $moment(props.item.huov_tm_dat).format("DD-MMM-YYYY ddd") }}</td>
                <td @click="$router.open('/klnt/onKlnt/' + props.item.klnt_encrid)" class="font-row">
                  <div class="flex">
                    <a>{{ props.item.klnt_naam }}</a>
                    <div v-if="!props.item.hasEmail" class="last-item"><v-icon small color="red"
                        style="margin-left: auto !important;">mdi-email-off-outline</v-icon></div>
                  </div>
                </td>
                <td class="font-row">{{ props.item.inpt_naam }}</td>
                <td class="format-amount font-row"><span v-if="props.item.huov_klnt_factuur !== ''">{{ props.item.huov_klnt_factuur | nl_numberformat | prefix_euro }}</span></td>
                <td class="format-amount font-row"><span v-if="props.item.huov_klnt_betaald !== ''">{{ props.item.huov_klnt_betaald | nl_numberformat | prefix_euro }}</span></td>
                <td class="format-amount font-row"><span v-if="props.item.huov_eign_factuur !== ''">{{ props.item.huov_eign_factuur | nl_numberformat | prefix_euro }}</span></td>
                <td class="format-amount font-row"><span v-if="props.item.huov_eign_betaald !== ''">{{ props.item.huov_eign_betaald | nl_numberformat | prefix_euro }}</span></td>
                <td>
                  <span v-if="props.item.hasComplaint" class="ml-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar size="24" class="mb-1 grid-item-error" v-on="on" v-bind="attrs">
                          <v-icon small color="red">mdi-thumb-down-outline</v-icon>
                        </v-avatar>
                      </template>
                      <span>Complaint</span>
                    </v-tooltip>
                  </span>
                  <span v-if="props.item.hasDamages" class="ml-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar size="24" class="mb-1 grid-item-warning" v-on="on" v-bind="attrs">
                          <v-icon small color="orange">mdi-glass-fragile</v-icon>
                        </v-avatar>
                      </template>
                      <span>Damages</span>
                    </v-tooltip>
                  </span>
                  <span v-if="props.item.hasPendingRebooking" class="ml-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar size="24" class="mb-1 grid-item-pending" v-on="on" v-bind="attrs">
                          <v-icon small color="blue">mdi-home-switch-outline</v-icon>
                        </v-avatar>
                      </template>
                      <span>Pending rebooking</span>
                    </v-tooltip>
                  </span>
                  <span v-if="props.item.hasOpenChange" class="ml-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar size="24" class="mb-1 grid-item-change" v-on="on" v-bind="attrs">
                          <v-icon small color="#FF8800">mdi-home-alert-outline</v-icon>
                        </v-avatar>
                      </template>
                      <span>Open change</span>
                    </v-tooltip>
                  </span>
                  <span v-if="props.item.hasGoodReview" class="ml-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar size="24" class="mb-1 grid-item-ok" v-on="on" v-bind="attrs">
                          <v-icon small color="green">mdi-message-processing-outline</v-icon>
                        </v-avatar>
                      </template>
                      <span>Good review</span>
                    </v-tooltip>
                  </span>
                  <span v-if="props.item.hasModerateReview" class="ml-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar size="24" class="mb-1 grid-item-warning" v-on="on" v-bind="attrs">
                          <v-icon small color="orange">mdi-message-processing-outline</v-icon>
                        </v-avatar>
                      </template>
                      <span>Moderate review</span>
                    </v-tooltip>
                  </span>
                  <span v-if="props.item.hasBadReview" class="ml-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar size="24" class="mb-1 grid-item-error" v-on="on" v-bind="attrs">
                          <v-icon small color="red">mdi-message-processing-outline</v-icon>
                        </v-avatar>
                      </template>
                      <span>Bad review</span>
                    </v-tooltip>
                  </span>
                  <span v-if="props.item.hasCancellationInsurance" class="ml-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar size="24" class="mb-1 grid-item-ok" v-on="on" v-bind="attrs">
                          <v-icon small color="success">mdi-anchor</v-icon>
                        </v-avatar>
                      </template>
                      <span>Cancellation insurance</span>
                    </v-tooltip>
                  </span>
                      <span v-if="props.item.hasUnderOccupancy && !isBookingOngoingOrCompleted(props.item)" class="ml-2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-avatar size="24" class="mb-1 grid-item-warning" v-on="on" v-bind="attrs">
                              <v-icon small color="orange">mdi-account-alert-outline</v-icon>
                            </v-avatar>
                          </template>
                          <span>Under occupancy</span>
                        </v-tooltip>
                      </span>
                      <span v-if="props.item.hasUnderOccupancy_ok" class="ml-2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-avatar size="24" class="mb-1 grid-item-pending" v-on="on" v-bind="attrs">
                              <v-icon small color="blue">mdi-account-alert-outline</v-icon>
                            </v-avatar>
                          </template>
                          <span>Under occupancy is ok by guest</span>
                        </v-tooltip>
                      </span>
                      <span v-if="props.item.isRefundable" class="ml-2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-avatar size="24" class="mb-1 grid-item-pending avatar-refund" v-on="on" v-bind="attrs">R</v-avatar>
                          </template>
                          <span>Refundable</span>
                        </v-tooltip>
                      </span>
                </td>
              </tr>
            </template>
          </v-data-table>
          <div v-if="!loading&&items.length>0" style="display: flex; align-items: center; justify-content :end; margin-top: 10px; font-size: small; color:grey;">
            <v-btn icon @click="goToFirstPage" :disabled="page === 1"><v-icon>mdi-chevron-double-left</v-icon></v-btn>
            <v-btn icon @click="goToPreviousPage" :disabled="page === 1"><v-icon>mdi-chevron-left</v-icon></v-btn>
            <div style="display: flex; justify-content: center; align-items: center; margin-left: 15px; margin-right: 15px; min-width: 80px;">Page {{ page }} of {{ lastPage }}</div>
            <v-btn icon @click="goToNextPage" :disabled="page === lastPage"><v-icon>mdi-chevron-right</v-icon></v-btn>
            <v-btn icon @click="goToLastPage" :disabled="page === lastPage"><v-icon>mdi-chevron-double-right</v-icon></v-btn>
            <div style="margin-left: 15px; min-width: 150px;">Record {{ startRecord }}-{{ eindRecord }} of {{ this.filteredItems.length }}</div>
          </div>
        </v-card>
      </div>
    </v-container>
    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main" />
    <standard_dialog ref="standard_dialog" @standard_dialog_close="parametersShow(false)" />
  </v-main>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import mxnumberformat from '@/mixins/amount_nl';
import select_hust_codes from "@/components/ui/selectors/select_hust_codes.vue"
import standard_dialog from '@/components/ui/standard_dialog.vue';
export default {
  components: {
    navBar,
    select_hust_codes,
    standard_dialog,
  },
  mixins: [mxnumberformat],
  data() {
    return {
      localStorageItem: 'search.huov.hustcodes',
      results: false,
      showParameters: true,
      items: [],
      huovCode: '',
      huisCode: '',
      HuovDatum: '',
      inpt_code: '',
      hulpDate: '',
      hustCodesSelected: [],
      hustCodes: [],
      huovDatVan: '',
      huovDatTm: '',
      huovDatVanmenu: false,
      huovDatTmmenu: false,
      huovAnnDatVan: '',
      huovAnnDatTm: '',
      huovAnnDatVanmenu: false,
      huovAnnDatTmmenu: false,
      huovVanDatVan: '',
      huovVanDatTm: '',
      huovVanDatVanmenu: false,
      huovVanDatTmmenu: false,
      huovTmDatVan: '',
      huovTmDatTm: '',
      huovTmDatVanmenu: false,
      huovTmDatTmmenu: false,
      inpt_codeKeuzes: [],
      huovTest: false,
      klntEmail: '',
      huovOtaCode: '',
      klntCode: '',
      klntNaam: '',
      klntTelefoon: '',
      klntOpenstaand: false,
      eignNaam: '',
      eignCode: '',
      eignEmail: '',
      eignTelefoon: '',
      eignOpenstaand: false,
      search: '',
      page: 1,
      loading: false,
      filterOpenAmountKlnt: false,
      filterOpenAmountEign: false,
      showClearButton: false,
      headers: [
        { text: 'Id', value: 'huov_code' },
        { text: 'Status', value: 'hust_code' },
        { text: 'Accommodation', value: 'huis_code' },
        { text: 'Booking', value: 'huov_dt' },
        { text: 'Persons', value: 'huov_pers' },
        { text: 'Arrival', value: 'huov_van_dat' },
        { text: 'Departure', value: 'huov_tm_dat' },
        { text: 'Guest', value: 'klnt_naam' },
        { text: 'Sales partner', value: 'inpt_naam' },
        { text: 'Guest Inv', value: 'huov_klnt_factuur_dec', align: "end" },
        { text: 'Guest Pay', value: 'huov_klnt_betaald_dec', align: "end" },
        { text: 'Host Inv', value: 'huov_eign_factuur_dec', align: "end" },
        { text: 'Host Pay', value: 'huov_eign_betaald_dec', align: "end" },
        { text: '', sortable: false, width: '7%' }
      ]
    }
  },
  computed: {
    lastPage() {
      return Math.ceil(this.filteredItems.length / this.getRowsPerPage());
    },
    startRecord() {
      return (this.page - 1) * this.getRowsPerPage() + 1;
    },
    eindRecord() {
      return Math.min(this.page * this.getRowsPerPage(), this.filteredItems.length);
    },
    filteredItems() {
      const lowerCaseSearch = this.search.toLowerCase();
      return this.items.filter(item => {
        const matchesSearch = !this.search || 
          item.huov_code.toLowerCase().includes(lowerCaseSearch) ||
          item.huis_code.toLowerCase().includes(lowerCaseSearch) ||
          item.klnt_naam.toLowerCase().includes(lowerCaseSearch) ||
          item.inpt_naam.toLowerCase().includes(lowerCaseSearch) ||
          item.huov_dt.toLowerCase().includes(lowerCaseSearch) ||
          item.huov_pers.toString().includes(lowerCaseSearch) ||
          item.huov_van_dat.toLowerCase().includes(lowerCaseSearch) ||
          item.huov_tm_dat.toLowerCase().includes(lowerCaseSearch) ||
          item.huov_klnt_factuur.toString().includes(lowerCaseSearch) ||
          item.huov_klnt_betaald.toString().includes(lowerCaseSearch) ||
          item.huov_eign_factuur.toString().includes(lowerCaseSearch) ||
          item.huov_eign_betaald.toString().includes(lowerCaseSearch);

        const matchesOpenAmountKlnt = !this.filterOpenAmountKlnt || (item.huov_klnt_factuur_dec - item.huov_klnt_betaald_dec) > 0;
        const matchesOpenAmountEign = !this.filterOpenAmountEign || (item.huov_eign_factuur_dec - item.huov_eign_betaald_dec) > 0;
        
        this.goToFirstPage()

        return matchesSearch && matchesOpenAmountKlnt && matchesOpenAmountEign;
      });
    },  
  },
  created() {
    this.$axios
      .post("ares/json/ares/huov/getSearchHuovParam.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getSearchHuovParam"
        },
        getSearchHuovParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
          this.parametersShow()
          this.param = res.data.getSearchHuovParam;
          this.inpt_codeKeuzes = res.data.getSearchHuovParam.inpt_codeKeuzes
        }
      });

  },
  methods: {
    isBookingOngoingOrCompleted(item){
       // Determines if a booking is ongoing or has been completed
       // Returns true if the booking has started (ongoing or completed), false if not yet started
       if (!item || !item.huov_van_dat_iso) {
          return false;
       }
       
       const today = new Date();
       today.setHours(0, 0, 0, 0); // Reset time to midnight for date-only comparison
       
       const startDate = new Date(item.huov_van_dat_iso);
       startDate.setHours(0, 0, 0, 0);
       
       // Return true if current date is >= start date (booking has started or completed)
       return today >= startDate;
    },
    goToFirstPage() {
      this.page = 1;
    },
    goToLastPage() {
      this.page = this.lastPage;
    },
    goToPreviousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    goToNextPage() {
      if (this.page < this.lastPage) {
        this.page++;
      }
    },
    getRowsPerPage() {
      const rowHeight = 48; // Approximate height of each row in pixels
      const headerHeight = 56; // Approximate height of the header in pixels
      const availableHeight = window.innerHeight - headerHeight - 200; // 200 is an approximate value for the height of the other elements on the page
      return Math.floor(availableHeight / rowHeight);
    },
    updateData(data) {
      this[data.field] = data.value;
    },
    parametersShow(clearParams=true) {
      if(clearParams) {
        this.huovCode = '';
        this.huisCode = '';
        this.huovDatVan = '';
        this.huovDatTm = '';
        this.huovAnnDatVan = '';
        this.huovAnnDatTm = '';
        this.huovVanDatVan = '';
        this.huovVanDatTm = '';
        this.huovTmDatVan = '';
        this.huovTmDatTm = '';
        this.klntCode = '';
        this.klntEmail = '';
        this.klntNaam = '';
        this.klntTelefoon = '';
        this.eignCode = '';
        this.eignEmail = '';
        this.eignNaam = '';
        this.eignTelefoon = '';
        this.inpt_code = '';
        this.huovOtaCode = '';
      }
      this.showParameters = true;
      this.items = []
      this.results = false
      this.search = ''
      this.filterOpenAmountKlnt = false
      this.filterOpenAmountEign = false
    },
    getHuov() {
      this.results = true;      
      this.showParameters = false;
      this.loading = true;
      this.items = [];
      this.$axios
        .post("ares/json/ares/huov/searchHuov2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchHuov"
          },
          searchHuov: {
            huov_code: this.huovCode,
            huis_code: this.huisCode,
            hust_codes: this.hustCodesSelected,
            huov_datum_van: this.huovDatVan,
            huov_datum_tm: this.huovDatTm,
            huov_ann_datum_van: this.huovAnnDatVan,
            huov_ann_datum_tm: this.huovAnnDatTm,
            huov_van_dat_van: this.huovVanDatVan,
            huov_van_dat_tm: this.huovVanDatTm,
            huov_tm_dat_van: this.huovTmDatVan,
            huov_tm_dat_tm: this.huovTmDatTm,
            klnt_code: this.klntCode,
            klnt_email: this.klntEmail,
            klnt_naam: this.klntNaam,
            klnt_telefoon: this.klntTelefoon,
            eign_naam: this.eignNaam,
            eign_code: this.eignCode,
            eign_email: this.eignEmail,
            eign_telefoon: this.eignTelefoon,
            huovTest: this.huovTest,
            inpt_code: this.inpt_code,
            huov_ota_code: this.huovOtaCode
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.$refs.standard_dialog.setWidth(450);
            this.$refs.standard_dialog.setTextClass("text-center text-body-1 pa-3 pt-6");
            this.$refs.standard_dialog.open('warning', 'Warning', res.data.error.message);
            this.showClearButton = true
            this.loading = false;
          } else {
            this.items = res.data.searchHuov;
            this.loading = false;               
            this.showClearButton = false
            localStorage.setItem(this.localStorageItem, this.hustCodesSelected);            
          }
        })
    }
  }
};

</script>
<style scoped>
.grid-item-error {
  background: transparent !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border: 1px solid red;
  color: red;
  cursor: default;
}
.grid-item-warning {
  background: transparent !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border: 1px solid orange;
  color: orange;
  cursor: default;
}
.grid-item-pending {
  background: transparent !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border: 0.5px solid dodgerblue;
  color: dodgerblue;
  cursor: default;
}
.grid-item-change {
  background: transparent !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border: 1px solid #FF8800;
  color: #FF8800;
  cursor: default;
}
.grid-item-ok {
  background: transparent !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border: 1px solid green;
  color: green;
  cursor: default;
}
.format-amount {
  text-align: end;
}
.font-row {
  font-size: smaller !important;
}
.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.last-item {
  margin-left: auto;
}
.chiptext {
  color: black !important;
}
.smallfont {
  font-size: small !important;
}
/* Custom font size for Refundable avatar */
.avatar-refund {
  font-size: 16px !important; /* Adjust as needed */
  border-width: 0.5px !important;
}
</style>